import React from 'react';
import styled from 'styled-components';

const TwitterContainer = styled.div`
  width: 100%;
  max-width: 400px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 15px;
  padding: 20px;
  margin-top: 20px;
  min-height: 500px;

  h2 {
    color: #ff4d00;
    margin-bottom: 15px;
    text-align: center;
  }

  .twitter-timeline {
    background: transparent !important;
  }
`;

const TwitterFeed = () => {
  return (
    <TwitterContainer>
      <h2>#PalisadesFire Updates</h2>
      <a 
        className="twitter-timeline" 
        data-theme="dark"
        data-chrome="noheader nofooter noborders transparent"
        data-tweet-limit="5"
        data-height="500"
        href="https://twitter.com/LAFDtalk?ref_src=twsrc%5Etfw">
        Loading tweets...
      </a>
    </TwitterContainer>
  );
};

export default TwitterFeed;
